module.exports = __webpack_public_path__ + "7c6801471227416c5fafd959526a3e30.svg";